import './CardWithLogo.css';

const LOGO_BASE = "https://x1.dixxip.com/dixcore/public/var/assets";

// variant "category": chip compatta per le categorie; "link": card per i singoli link
const CardWithLogo = (props) => {
    const { icon, name, url, target, id, fetchBookmarksLinks, selectBookmark, subTitle, logo, modal, selected, variant = "link" } = props;
    const action = fetchBookmarksLinks || selectBookmark;
    const onKeyDown = (e) => {
        if (!url && action && (e.key === "Enter" || e.key === " ")) {
            e.preventDefault();
            e.currentTarget.click();
        }
    };

    return (
        <a
            key={id}
            {...(url ? { href: url } : { onClick: action, role: "button", tabIndex: 0, onKeyDown })}
            target={target}
            className={`bm-item bm-item--${variant}${selected ? " is-selected" : ""}`}
            aria-pressed={variant === "category" ? !!selected : undefined}
            {...(modal ? { "data-toggle": "modal", "data-target": `#${modal}` } : {})}
        >
            <span className={`bm-media${!icon && logo?.fullpath ? " bm-media--logo" : ""}`} aria-hidden="true">
                {icon
                    ? <span className="material-symbols-outlined">{icon}</span>
                    : logo?.fullpath
                        ? <img src={`${LOGO_BASE}${logo.fullpath}`} alt="" />
                        : <span className="material-symbols-outlined">link</span>}
            </span>
            <span className="bm-text">
                <span className="bm-name">{name}</span>
                {subTitle ? <span className="bm-sub">{subTitle}</span> : null}
            </span>
            {variant === "link" && <span className="material-symbols-outlined bm-arrow" aria-hidden="true">arrow_outward</span>}
        </a>
    );
}
export default CardWithLogo;
